import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from './storage.service';

@Injectable()
export class HttpInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private toast: ToastrService,
    private storage: StorageService,
  ) {
  }

  intercept( request: HttpRequest<unknown>, next: HttpHandler ): Observable<HttpEvent<unknown>> {
    const token = this.storage.getItem( 'inbox-token' );
    if ( token ) {
      request = request.clone( { headers: request.headers.set( 'Authorization', `Bearer ${token}` ) } );
    }

    if ( !request.headers.has( 'Content-Type' ) ) {
      request = request.clone( { headers: request.headers.set( 'Content-Type', 'application/json' ) } );
    }

    request = request.clone( { headers: request.headers.set( 'Accept', 'application/json' ) } );

    return next.handle( request ).pipe(
      map( ( event: HttpEvent<any> ) => {
        if ( event instanceof HttpResponse ) {
        }
        return event;
      } ),
      catchError( ( response: HttpErrorResponse ) => {
        switch ( response.status ) {
          case 400:
            this.toast.warning( response.error.message );
            break;
          case 401:
            // this.router.navigate( [ 'login' ] );
            break;
          case 404:
            this.toast.warning( response.error.message );
            break;
          case 422:
            this.toast.warning( response.error.errors );
            break;
          case 500:
            // Manejor de error
            break;
          default:
            break;
        }

        return throwError( response );
      } ),
    );
  }
}
